import { config } from '../../config'

// type Output = {
//   office: string
//   blog: string
//   main: string
//   job: string
//   shop: string
// }

// export const getServiceURL = (locale: string): Output => {
//   let prefix: string
//   const loc = locale === 'ru' ? locale : 'io'

//   switch (process.env.NEXT_PUBLIC_NODE_ENV) {
//     case 'development':
//       prefix = 'dev'
//       break
//     case 'stage':
//       prefix = 'stage'
//       break
//     default:
//       prefix = ''
//   }

//   return {
//     office: `https://${prefix}${
//       prefix !== '' ? '-' : prefix
//     }office.plandi.${loc}`,
//     blog: `https://${prefix}${prefix !== '' ? '.' : prefix}plandi.${loc}/blog`,
//     main: `https://${prefix}${prefix !== '' ? '.' : prefix}plandi.${loc}`,
//     job: `https://${prefix}${prefix !== '' ? '.' : prefix}plandi.${loc}/job`,
//     shop: `https://${prefix}${prefix !== '' ? '.' : prefix}plandi.${loc}/shop`
//   }
// }

//deprecated
export const SERVICES_URL = config.isDev
  ? ({
      office: 'https://dev-office.plandi.io',
      // officeRu: 'https://dev-office.plandi.ru',
      blog: 'https://dev.plandi.io/blog',
      main: 'https://dev.plandi.io',
      // mainRu: 'https://dev.plandi.ru',
      // mainEng: 'https://dev.plandi.io',
      job: 'https://dev.plandi.io/job',
      shop: 'https://dev.plandi.io/shop'

      // jobRu: 'https://dev.plandi.ru/job',
      // jobEng: 'https://dev.plandi.io/job',
      // shopRu: 'https://dev.plandi.ru/shop',
      // shopEng: 'https://dev.plandi.io/shop'
    } as const)
  : config.isStage
  ? {
      office: 'https://stage-office.plandi.io',
      // officeRu: 'https://stage-office.plandi.ru',
      blog: 'https://stage.plandi.io/blog',
      main: 'https://stage.plandi.io',
      // mainRu: 'https://stage.plandi.ru',
      // mainEng: 'https://stage.plandi.io',
      job: 'https://stage.plandi.io/job',
      // jobRu: 'https://stage.plandi.ru/job',
      // jobEng: 'https://stage.plandi.io/job',
      shop: 'https://stage.plandi.io/shop'
      // shopRu: 'https://stage.plandi.ru/shop',
      // shopEng: 'https://stage.plandi.io/shop'
    }
  : ({
      office: 'https://office.plandi.io',
      // officeRu: 'https://office.plandi.ru',
      blog: 'https://plandi.io/blog',
      main: 'https://plandi.io',
      // mainRu: 'https://plandi.ru',
      // mainEng: 'https://plandi.io',
      job: 'https://plandi.io/job',
      // jobRu: 'https://plandi.ru/job',
      // jobEng: 'https://plandi.io/job',
      shop: 'https://plandi.io/shop'
      // shopRu: 'https://plandi.ru/shop',
      // shopEng: 'https://plandi.io/shop'
    } as const)
